"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = function (getter, fallback) {
    try {
        var val = getter();
        return val !== void 0 ? val : fallback;
    }
    catch (e) {
        return fallback;
    }
};
exports.omit = function (key) { return function (obj) {
    var _a = key, _v = obj[_a], rest = __rest(obj, [typeof _a === "symbol" ? _a : _a + ""]);
    return rest;
}; };
exports.omitMedia = exports.omit('media');
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixstores-platform-common/dist/src/utils.js
// module id = 1
// module chunks = 0